import 'slick.min.js'
import 'jquery.countTo.js'
import 'jquery.maskedinput.js'
import 'jquery.validate.js'

import '@chenfengyuan/datepicker/dist/datepicker';
import '@chenfengyuan/datepicker/i18n/datepicker.ru-RU';

import TheaterVysotaLogo from 'images/theater_logo/white_logo/vysota.png';
import TheaterNevaLogo from 'images/theater_logo/white_logo/neva.png';
import TheaterElbrusLogo from 'images/theater_logo/white_logo/elbrus.png';
import TheaterMarsLogo from 'images/theater_logo/white_logo/mars.png';
import TheaterRassvetLogo from 'images/theater_logo/white_logo/rassvet.png';
import TheaterBudapeshtLogo from 'images/theater_logo/white_logo/budapesht.png';
import TheaterSofiaLogo from 'images/theater_logo/white_logo/sofia.png';
import TheaterKirgiziaLogo from 'images/theater_logo/white_logo/kirgizia.png';
import TheaterBaikonurLogo from 'images/theater_logo/white_logo/baikonur.png';
import TheaterEkranLogo from 'images/theater_logo/white_logo/ekran.png';

import url from 'url';

const queryParser = require('query-string');

$(document).ready(function () {
  // Раскрытие расписания кинотеатра по клику
  $(".show_schedule_theater_info").click(function () {
    const id = $(this).attr("id");
    $('.show_schedule_picked_theater_info, .show_schedule_theaters_schedule').removeClass('active');
    $('#' + id + '_active, #schedule_' + id).addClass('active')
    $('.show_schedule_theater_info').removeClass('hidden');
    $(this).add('.change_schedule_notice').addClass('hidden');
  });

  // Сокрытие расписание кинотеатра по клику
  $(".show_schedule_picked_theater_info").click(function () { 
    $('.show_schedule_picked_theater_info, .show_schedule_theaters_schedule').removeClass('active');
    $('.show_schedule_theater_info, .change_schedule_notice').removeClass('hidden');
  });

  // Если есть селектор id главной страницы, то проводим обработку урла
  if ($('#home_page').length > 0) {
    // Получаем текущий урл
    const parsedUrl = url.parse(window.location.href)
    // Парсим query-параметры из урла
    const parsedQuery = queryParser.parse(parsedUrl.query)
    
    // Если query-параметры есть и среди них есть параметры hash и id,
    // то пробуем отправить запрос на подтверждение учетной записи
    if (Object.keys(parsedQuery).length > 0 && parsedQuery.hash && parsedQuery.id) {
      $.ajax({
        url: 'registration_requests/' + parsedQuery.id + '/confirm/' + parsedQuery.hash,
        type: 'PATCH',
        data: {}
      });
    }
  }

  $('[data-toggle="datepicker"]').datepicker({ language: 'ru-RU' });

	// header fixed
	$(window).scroll( function(){
		if ($(this).scrollTop() > 50){
			$('.header').addClass('fixed');
		}else{
			$('.header').removeClass('fixed');
		}
	});

	// mob nav
	$(document).on('click','.mob-nav-icon',function(e){
		e.preventDefault();
		if($(this).hasClass('active')){
			$('.header-nav').removeClass('vis');
			$('.mob-nav-icon').removeClass('active');
		}else{
			$('.header-nav').addClass('vis');
			$('.mob-nav-icon').addClass('active');
		}
	});

	// scroll
	$('.scroll').click(function(e){
		e.preventDefault();
		var selected = $(this).attr('href').replace('/', '');
		$.scrollTo(selected, 1000, {offset: -70});
		$('.header-nav').removeClass('vis');
		$('.mob-nav-icon').removeClass('active');
		return false;
	});

	// mask for phone
	$("input[name='registration_request[phone]']").mask("+7 (999) 999 99 99");
	$("input[name='registration_request[vista_card_number]']").mask("9999 99999 99999");
	// form
	$('form').each(function(){
		$(this).validate({
			rules: {
				'registration_request[phone]': {
					required: true,
					minlength: 6,
				},
				'registration_request[name]': {
					required: true,
					minlength: 2,
				},
				'registration_request[date_of_birth]': {
					required: true,
					minlength: 6,
                    regex: "^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$"
				},
				'registration_request[email]': {
					required: true,
          email: true
				}
			}
		});
	});
	$.validator.messages.required = 'Обязательно для заполнения';
	$.validator.messages.email = 'Введите валидный e-mail адрес';
    $.validator.addMethod(
            "regex",
            function(value, element, regexp) {
                var re = new RegExp(regexp);
                return this.optional(element) || re.test(value);
            },
            "Проверьте корректность данных."
    );

	// info-hidden
	$(document).on('click','.info-trigger a',function(e){
		e.preventDefault();
		if($(this).hasClass('active')){
			$('.info-hidden').slideUp();
			$(this).removeClass('active');
		}else{
			$('.info-hidden').slideDown();
			$(this).addClass('active');
			if($(window).width() < 1023){
				$.scrollTo('.info-hidden', 1000, {offset: -70});
			}
		}
	});

	// count numbers
	var document_top = $(document).scrollTop();
	var height = $(window).height();
	var offset2 = $('.info').offset().top - height + height/6;
	if(document_top > offset2){
		$('.start').countTo();
		$('.info .count').removeClass('start');
	}

	// animation trigger
	var document_top = $(document).scrollTop();
	var height = $(window).height();
	$('.animatable').each(function(){
		var offset = $(this).offset().top - height + height/6;
		if(document_top > offset){
			$(this).addClass('animated');
		}else{
			$(this).removeClass('animated');
		}
	});
	$(window).scroll( function(e){
		var document_top = $(document).scrollTop();
		var height = $(window).height();
		$('.animatable').each(function(){
			var offset = $(this).offset().top - height + height/6;
			if(document_top > offset){
				$(this).addClass('animated');
			}else{
				$(this).removeClass('animated');
			}
		});

	});

    $('#subscribe-form').submit(function(e){
        if($(this).valid()){

            e.preventDefault();

            $.ajax({
                url: '/subscribe',
                type: 'POST',
                data: {email: $('.subscribe-input').val()},
                success: function(data){

                    if(data.error) {
                        $.fancybox.open( $('#error-popup'), {
                           touch: false
                        });

                    } else {
                        $.fancybox.open( $('#info-popup'), {
                           touch: false
                        });
                    }

                    console.log(data.error);
                },
                fail: function(){
                    console.log(data);
                    $.fancybox.open( $('#error-popup'), {
                       touch: false
                    });
                }
            });

        }

        return false;
    });


    $('#register-form').submit(function(e){
        if($(this).valid()){

            e.preventDefault();
            var el = $(this);
            $.ajax({
                url: '/register',
                type: 'POST',
                data: $(el).serialize(),
                success: function(data){
                    if(data.error) {
						grecaptcha.reset();

						if(data.message){
							$('#error-popup .popup-text').html(data.message);
						} else {
							$('#error-popup .popup-text').html('Произошла ошибка. Пожалуйста, проверьте корректность введенных данных')
						}

                        $.fancybox.open( $('#error-popup'), {
                           touch: false
                        });

                    } else {
                        $.fancybox.open( $('#info-popup'), {
                           touch: false
                        });
                    }

                    console.log(data.error);
                },
                fail: function(){
                    console.log(data);
                    $.fancybox.open( $('#error-popup'), {
                       touch: false
                    });
                }
            });

        }

        return false;
    });

    if(location.hash == '#confirm-success'){
        $.fancybox.open( $('#confirm-success'), {
           touch: false
        });
    }

    if(location.hash == '#confirm-error'){
        $.fancybox.open( $('#confirm-error'), {
           touch: false
        });
    }

    if(location.hash == '#subscribe-success'){
        $.fancybox.open( $('#info-popup'), {
           touch: false
        });
    }

  ymaps.ready(init);

  function init(){
    // Создание карты.
    var myMap = new ymaps.Map("cinemas_map", {
        // Координаты центра карты.
        // Порядок по умолчанию: «широта, долгота».
        // Чтобы не определять координаты центра карты вручную,
        // воспользуйтесь инструментом Определение координат.
        center: [55.76, 37.64],
        // Уровень масштабирования. Допустимые значения:
        // от 0 (весь мир) до 19.
        zoom: 11,
        behaviors: ['default']
    });
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      myMap.behaviors.disable('drag');
    }
    
    myMap.behaviors.disable('scrollZoom');

    const dataPlacemarks = [
      {id: 53, className: 'open_date_long', name: TheaterVysotaLogo, address: 'Юных Ленинцев, 52, метро Кузьминки', coords: [55.699781, 37.765381], openDate: "уже открыт", campaign: 'vysota'},
      {id: 54, className: 'open_date_long', name: TheaterNevaLogo, address: 'Беломорская, 16а, метро Речной вокзал', coords: [55.862681, 37.471192], openDate: "уже открыт", campaign: 'neva'},
      {id: 55, className: 'open_date_long', name: TheaterElbrusLogo, address: 'Кавказский б-р, 17, метро Кантемировская', coords: [55.630924, 37.670672], openDate: "1 кв. 2022", campaign: 'elbrus'},
      {id: 56, className: 'open_date_long', name: TheaterMarsLogo, address: 'Инженерная ул., 1, метро Бибирево', coords: [55.878768, 37.582260], openDate: "уже открыт", campaign: 'mars'},
      {id: 57, className: 'open_date_long', name: TheaterRassvetLogo, address: 'Зои и Александра Космодемьянских, 23, метро Войковская', coords: [55.824106, 37.518093], openDate: "уже открыт", campaign: 'rassvet'},
      {id: 58, className: 'open_date_long', name: TheaterBudapeshtLogo, address: 'Ул. Лескова, 14, метро Бибирево', coords: [55.897327, 37.604484], openDate: "уже открыт", campaign: 'budapesht'},
      {id: 59, className: 'open_date_long', name: TheaterSofiaLogo, address: 'Сиреневый бульвар, 31, метро Щёлковская', coords: [55.803818, 37.800541], openDate: "уже открыт", campaign: 'sofiya'},
      {id: 60, className: 'open_date_long', name: TheaterKirgiziaLogo, address: 'Зеленый проспект, 81,метро Новогиреево', coords: [55.751776, 37.820160], openDate: "1 кв. 2022", campaign: 'kirgiziya'},
      {id: 61, className: 'open_date_long', name: TheaterBaikonurLogo, address: 'ул. Декабристов, 17, метро Отрадное', coords: [55.864960, 37.605095], openDate: "1 кв. 2022", campaign: 'baykonur'},
      {id: 62, className: 'open_date_long', name: TheaterEkranLogo, address: 'Новочеркасский бульвар, 21А, метро Марьино', coords: [55.647925, 37.727769], openDate: "1 кв. 2022", campaign: 'ekran'}
    ];

    // Макет создается с помощью фабрики макетов с помощью текстового шаблона.
    const BalloonLayout = ymaps.templateLayoutFactory.createClass(
      '<div class="map_balloon_block">' +
        '<div class="cinema_name"><img src="{{properties.name}}" height="18px" /></div>' +
        '<div class="cinema_address">{{properties.address}}</div>' +
        '<div class="cinema_bottom">' +
        '<div class="cinema_open_date"><span class="{{properties.className}}">Открытие:</span>{{properties.openDate}}</div>' +
        '<div class="cinema_link"><a href="https://karofilm.ru/theatres?id={{properties.id}}&utm_source=welcome&utm_medium=button&utm_campaign={{properties.campaign}}" target="_blank"><span>karofilm.ru</span></a></div>' +
        '</div>' +
        '<a class="close" href="#"></a>' +
        '<div class="arrow"></a>' +
      '</div>', 
      {
        build: function () {
          // Сначала вызываем метод build родительского класса.
          BalloonContentLayout.superclass.build.call(this);
          this._$element = $('.map_balloon_block', this.getParentElement());
          this._$element.find('.close').on('click', $.proxy(this.onCloseClick, this));
          this.applyElementOffset();
        },

        // Аналогично переопределяем функцию clear, чтобы снять
        // прослушивание клика при удалении макета с карты.
        clear: function () {
          this._$element.find('.close').off('click');
          BalloonContentLayout.superclass.clear.call(this);
        },

        // Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
        // @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
        // @function
        // @name onSublayoutSizeChange
        //
        onSublayoutSizeChange: function () {
          MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

          if(!this._isElement(this._$element)) {
            return;
          }

          this.applyElementOffset();

          this.events.fire('shapechange');
        },

        // Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
        // @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
        // @function
        // @name applyElementOffset
        //
        applyElementOffset: function () {
          console.log(this._$element[0].offsetWidth)
          console.log(this._$element[0].offsetHeight)
          console.log(this._$element)
          this._$element.css({
              left: -(this._$element[0].offsetWidth / 2),
              top: -(this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight)
          });
        },
        
        // Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
        // @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
        // @function
        // @name onCloseClick
        //
        onCloseClick: function (e) {
          e.preventDefault();

          this.events.fire('userclose');
        },

        // Используется для автопозиционирования (balloonAutoPan).
        // @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
        // @function
        // @name getClientBounds
        // @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
        //
        getShape: function () {
          if(!this._isElement(this._$element)) {
            return MyBalloonLayout.superclass.getShape.call(this);
          }

          var position = this._$element.position();

          return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
              [position.left, position.top], [
                  position.left + this._$element[0].offsetWidth,
                  position.top + this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight
              ]
          ]));
        },

        // Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
        // @function
        // @private
        // @name _isElement
        // @param {jQuery} [element] Элемент.
        // @returns {Boolean} Флаг наличия.
        //
        _isElement: function (element) {
          return element && element[0] && element.find('.arrow')[0];
        }
      }
    );

    // Макет создается с помощью фабрики макетов с помощью текстового шаблона.
    const BalloonContentLayout = ymaps.templateLayoutFactory.createClass(
      '<div>' +
      '</div>', 
      {
        build: function () {
          // Сначала вызываем метод build родительского класса.
          BalloonContentLayout.superclass.build.call(this);
        },

        // Аналогично переопределяем функцию clear, чтобы снять
        // прослушивание клика при удалении макета с карты.
        clear: function () {
          BalloonContentLayout.superclass.clear.call(this);
        },
      }
    );

    var myCollection = new ymaps.GeoObjectCollection({}, {
        preset: 'islands#redIcon', //все метки красные
    });
    
    dataPlacemarks.forEach(({ id, className, name, coords, address, openDate, campaign }) => {
      myCollection.add(new ymaps.Placemark(coords, {
        id, className, name, address, openDate, campaign
      }, {
        balloonLayout: BalloonLayout,
        // balloonContentLayout: BalloonContentLayout,
        balloonPanelMaxMapArea: 0,
        iconLayout: 'default#image',
        iconImageHref: 'https://karofilm.ru/img/cinema/map-icon.png',
        iconImageSize: [30, 42],
        iconImageOffset: [-3, -42]
        }));
    });
    
    myMap.geoObjects.add(myCollection);  
  }
});
